<template>
	<div class="step-credential-field mb-2">
		<b-input-group>
			<template #prepend>
				<b-input-group-text class="cred-label">
					<span class="cred-label-text">{{ label }}</span>
					<span class="ml-auto d-flex align-items-center flex-shrink-0">
						<b-badge v-if="status === 'configured'" variant="success" class="flex-shrink-0">Renseignée</b-badge>
						<b-badge v-else variant="secondary" class="flex-shrink-0" :title="scope === 'user' ? 'Aucune clé personnelle : la clé commune (ou le relai par défaut) est utilisée pour vous.' : 'Non renseignée ici : une autre clé (par défaut) peut prendre le relai si disponible.'">Non renseignée</b-badge>
						<b-badge
							v-if="status !== 'configured' && scope === 'client' && admin_shared_active"
							variant="info"
							class="ml-1 flex-shrink-0"
							title="Une clé SMD partagée est activée pour ce client (voir /admin_client) : elle sera utilisée automatiquement si aucune clé n'est renseignée ici.">
							SMD
						</b-badge>
					</span>
				</b-input-group-text>
			</template>
			<template #append>
				<b-button
					v-if="status === 'configured'"
					variant="outline-secondary"
					class="cred-eye-btn"
					@click="toggle_view"
					><i :class="visible ? 'fas fa-eye' : 'fas fa-eye-slash'"></i
				></b-button>
				<b-button variant="outline-secondary" class="cred-action-btn" @click="editing = !editing">
					{{ status === 'configured' ? 'Modifier' : (scope === 'user' ? 'Ajouter pour moi' : 'Renseigner') }}
				</b-button>
			</template>
			<b-form-input
				v-if="status === 'configured'"
				:type="visible ? 'text' : 'password'"
				:value="visible ? current_value : '••••••••'"
				readonly
				disabled></b-form-input>
			<b-form-input
				v-else
				readonly
				disabled
				placeholder="Non renseignée"></b-form-input>
		</b-input-group>

		<div v-if="editing" class="mt-1">
			<b-input-group>
				<b-form-input
					:type="new_value_visible ? 'text' : 'password'"
					v-model="new_value"
					placeholder="Nouvelle valeur"></b-form-input>
				<template #append>
					<b-button
						variant="outline-secondary"
						class="cred-eye-btn"
						@click="new_value_visible = !new_value_visible"
						><i :class="new_value_visible ? 'fas fa-eye' : 'fas fa-eye-slash'"></i
					></b-button>
					<b-button
						variant="success"
						:disabled="!new_value || saving"
						@click="save"
						>Enregistrer</b-button
					>
					<b-button variant="outline-secondary" @click="editing = false">Annuler</b-button>
				</template>
			</b-input-group>
		</div>
	</div>
</template>

<script>
	import credentials from "../services/credentials";
	import store from "../store";
	import { ADMIN_SHARED_CREDENTIALS } from "../config/step_credentials_fields";

	export default {
		name: "step_credential_field",
		props: {
			credentialName: {
				type: String,
				required: true,
			},
			label: {
				type: String,
				default: "",
			},
			/** "client" (clé commune, partagée) ou "user" (clé personnelle, propre à l'utilisateur courant). */
			scope: {
				type: String,
				default: "client",
			},
		},
		data() {
			return {
				status: "loading", // loading | configured | absent
				uid: null,
				visible: false,
				current_value: "",
				editing: false,
				new_value: "",
				new_value_visible: false,
				saving: false,
			};
		},
		computed: {
			admin_shared_active() {
				var map = ADMIN_SHARED_CREDENTIALS[this.credentialName];
				if (!map) return false;
				var client = store.state.client;
				return !!(
					client &&
					client.details &&
					client.details.credentials &&
					client.details.credentials[map.type] &&
					client.details.credentials[map.type][map.key]
				);
			},
		},
		methods: {
			refresh: async function () {
				this.status = "loading";
				var all = await credentials.getAll();
				var is_user_scope = this.scope === "user";
				var found = all.find((c) => c.name === this.credentialName && !!c.client_user_uid === is_user_scope);

				if (found) {
					this.uid = found.uid;
					this.status = "configured";
				} else {
					this.uid = null;
					this.status = "absent";
				}
				this.$emit("status", { name: this.credentialName, scope: this.scope, status: this.status });
			},
			toggle_view: async function () {
				if (this.visible) {
					this.visible = false;
					return;
				}
				if (!this.current_value) {
					var decrypted = await credentials.getOne(this.uid);
					this.current_value = decrypted.value;
				}
				this.visible = true;
			},
			save: async function () {
				this.saving = true;
				try {
					if (this.uid) {
						await credentials.put(this.uid, this.new_value);
					} else {
						await credentials.post(this.credentialName, this.new_value, this.scope === "user");
					}
					this.new_value = "";
					this.new_value_visible = false;
					this.editing = false;
					this.visible = false;
					this.current_value = "";
					await this.refresh();
				} finally {
					this.saving = false;
				}
			},
		},
		mounted: async function () {
			await this.refresh();
		},
	};
</script>

<style scoped>
	.step-credential-field .cred-label {
		display: flex;
		align-items: center;
		width: 280px;
		min-width: 280px;
		max-width: 280px;
		white-space: nowrap;
	}
	.step-credential-field .cred-label-text {
		margin-right: 0.5rem;
		white-space: nowrap;
	}
	.step-credential-field .cred-action-btn {
		min-width: 130px;
		white-space: nowrap;
	}
</style>
